import { createReducer } from '../../../../store.model';

import { AddCommitmentNotesResult } from './state/add-commitment-notes.action';
import { addCommitmentNotesResultReducer } from './state/add-commitment-notes.reducer';
import { EditNotesFocus } from './state/edit-notes-focus.action';
import { editNotesFocusReducer } from './state/edit-notes-focus.reducer';
import { FilterQuotes } from './state/filter-quotes.action';
import { filterQuotesReducer } from './state/filter-quotes.reducer';
import { Reload } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { ResetNav } from './state/reset-nav.action';
import { resetNavReducer } from './state/reset-nav.reducer';
import { SelectQuotes } from './state/select-quotes.action';
import { selectQuotesReducer } from './state/select-quotes.reducer';
import { ActionType } from './teamschat-transcript-dialog.action';
import {
    defaultState,
    TeamschatTranscriptDialogState,
} from './teamschat-transcript-dialog.state';

const { builder, reducer } = createReducer<
    ActionType,
    TeamschatTranscriptDialogState
>(defaultState());

builder.add<Reload>(ActionType.COACHING_DETAIL__TCTD__RELOAD, reloadReducer);
builder.add<Reload>(
    ActionType.COACHING_DETAIL__TCTD__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<FilterQuotes>(
    ActionType.COACHING_DETAIL__TCTD__FILTER_QUOTES,
    filterQuotesReducer,
);

builder.add<SelectQuotes>(
    ActionType.COACHING_DETAIL__TCTD__SELECT_QUOTES,
    selectQuotesReducer,
);

builder.add<EditNotesFocus>(
    ActionType.COACHING_DETAIL__TCTD__EDIT_NOTES_FOCUS,
    editNotesFocusReducer,
);

builder.add<AddCommitmentNotesResult>(
    ActionType.COACHING_DETAIL__TCTD__ADD_COMMITMENT_NOTES_RESULT,
    addCommitmentNotesResultReducer,
);

builder.add<ResetNav>(
    ActionType.COACHING_DETAIL__TCTD__RESET_NAV,
    resetNavReducer,
);

export const teamschatTranscriptDialogReducer = reducer;
